/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import {
  Grid,
  Dropdown,
  Divider,
  Loader,
  Container,
  Tab,
  Menu
} from 'semantic-ui-react';
import _ from 'lodash';

import months from '../../utils/months';
import ComparerTab from './ComparerTab';
import { getTargetingSentencelines, getAds } from '../../fbApi/Ad';
import { getAccounts } from '../../services/AccountService';
import { getCampaigns, getCampaign } from '../../fbApi/Campaign';
import { getAdPreview } from '../../fbApi/AdPreview';
import { getCanvas } from '../../fbApi/Canvas';
import getLead from '../../fbApi/Lead';
import './AdComparer.css';

class AdComparer extends Component {
  state = {
    accountOptions: null,
    showYearLoader: false,
    showYearSelector: false,
    showFirstMonthSelector: false,
    showSecondMonthSelector: false,
    processing: false,
    message: '',
    tabs: [],
    showTabs: false,
    campaignName: {
      PRODUCT_CATALOG_SALES: null,
      LEAD_GENERATION: null,
      VIDEO_VIEWS: null,
      LINK_CLICKS: null,
      CONVERSIONS: null
    },
    campaignMonth: {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: []
    },
    token: this.props.getFbToken()
  };

  componentDidMount() {
    this.props.setSectionTitle('Ad Comparer');
    this.props.saveGTMEvent('Ad Comparer', 'Ad Comparer');
    this.getAdAccounts();
  }

  onAccountSelect = (event, data) => {
    const account = _.find(
      data.options,
      (option) => option.value === data.value
    );

    const accountId = account.value;
    const accountName = account.text;

    this.setState({
      showTabs: false,
      showFirstMonthSelector: false,
      showSecondMonthSelector: false,
      selectedFirstYear: '',
      selectedSecondYear: '',
      adAccountId: accountId,
      adAccountName: accountName,
      selectedFirstMonth: '',
      selectedSecondMonth: '',
      adsToCompareFirst: [],
      adsToCompareSecond: []
    });

    this.getCampaigns(data.value);
  };

  getCampaigns = async (id) => {
    try {
      this.setState({
        campaigns: [],
        showYearLoader: true
      });

      await this.queryCampaigns(id);

      this.setState({
        campaigns: this.state.selectedCampaigns,
        showYearSelector: true,
        showYearLoader: false
      });
    } catch (error) {
      console.log(error);
    }
  };

  queryCampaigns = async (id) => {
    const screen = 'Ad Comparer';
    const campaigns = await getCampaigns(id, this.state.token, screen);
    const result = campaigns.data;

    const assocCampaigns = [];
    const campaignMonths = [];
    const years = [];

    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);
      assocCampaigns[year + month] = {
        month_year: null,
        ids: []
      };
    });
    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);

      const existentYear = years.filter((item) => item.text === year);

      if (existentYear.length === 0) {
        years.push({
          value: year,
          text: year
        });
      }

      assocCampaigns[year + month].month = month;
      assocCampaigns[year + month].year = year;
      assocCampaigns[year + month].ids.push(campaign.id);
    });

    _.mapKeys(assocCampaigns, (month) => {
      if (month) {
        campaignMonths.push(month);
      }
    });

    const campaignOptions = _.map(campaignMonths, (op, index) => {
      const month = months.filter((item) => item.shortName === op.month);

      return {
        key: index,
        value: op.ids.join(','),
        text: month[0] ? month[0].monthName : op.month,
        accountId: id,
        year: op.year
      };
    });

    // eslint-disable-next-line no-unused-vars
    const monthsOpt = _.map(campaignOptions, (op, index) => ({
      value: op.text,
      text: op.text,
      campaignsIds: op.value
    }));

    this.setState({
      selectedCampaigns: campaignOptions,
      data: result,
      years,
      months: monthsOpt
    });
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: _.sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      alert(error);
    }
  };

  onYearSelect = (event, data) => {
    const value = data.value;
    const filteredCampaigns = this.state.campaigns.filter(
      (val) => val.year === value
    );

    const selector = data.id === 'FirstYearSelector' ? 'First' : 'Second';

    this.setState({
      [`show${selector}MonthSelector`]: true,
      [`show${selector}MonthLoader`]: false,
      [`selected${selector}Year`]: value,
      [`${selector}Months`]: filteredCampaigns,
      [`selected${selector}Month`]: ''
    });
  };

  onMonthSelect = async (event, data) => {
    const value = data.value;
    const selector = data.id === 'FirstMonthSelector' ? 'First' : 'Second';
    this.setState({ [`selected${selector}Month`]: value });
    this.setState(
      // eslint-disable-next-line no-unused-vars
      (state) => ({ [`selected${selector}Month`]: value }),
      () => {
        this.getAdsToCompare();
      }
    );
  };

  getAdsToCompare = async () => {
    if (this.state.selectedFirstMonth && this.state.selectedSecondMonth) {
      this.setState({
        processing: true,
        message: 'Comparing...',
        showTabs: false
      });
      const idsFirst = this.state.selectedFirstMonth.split(',');
      const idsSecond = this.state.selectedSecondMonth.split(',');
      await this.getAds(idsFirst, 'First');
      await this.getAds(idsSecond, 'Second');
      this.setState({ processing: false, message: '', showTabs: true });
    }
  };

  sortAdsByFormat = (firstAds, secondAds) => {
    const commonAdsFirst = [];
    const commonAdsSecond = [];
    const differentAdsFirst = [];
    const differentAdsSecond = [];

    firstAds.map((ad) => {
      const secondAd = secondAds.find((item) => item.ad_name === ad.ad_name);
      if (secondAd) {
        commonAdsFirst.push(ad);
        commonAdsSecond.push(secondAd);
      } else {
        differentAdsFirst.push(ad);
      }
    });

    secondAds.map((ad) => {
      const addedAd = commonAdsSecond.find(
        (item) => item.ad_name === ad.ad_name
      );
      if (!addedAd) {
        differentAdsSecond.push(ad);
      }
    });

    const sortedAdsFirst = commonAdsFirst.concat(differentAdsFirst);
    const sortedAdsSecond = commonAdsSecond.concat(differentAdsSecond);

    return { sortedAdsFirst, sortedAdsSecond };
  };

  getAds = async (ids, selection) => {
    this.setState({
      campaignIds: ids,
      showAdsLoading: true
    });

    const allCampaigns = await Promise.all(
      _.map(ids, async (id) => {
        const campaign = await getCampaign(id, this.state.token);

        const campaignObjective = campaign.objective;
        const cn = this.state.campaignName;
        cn[campaignObjective] = campaign.name.replace(/_/g, ' ');
        this.setState({ campaignName: cn });
        const resultAds = await getAds(campaign.id, this.state.token);
        const ads = resultAds.data;

        const previewObjects = ads.map(async (ad) =>
          this.buildPreviewObject(ad, selection)
        );
        return Promise.all(previewObjects);
      })
    );

    const ccm = {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: []
    };
    _.map(allCampaigns, (c) => {
      if (c[0] && ccm[c[0].campaignObjective]) {
        ccm[c[0].campaignObjective] = ccm[c[0].campaignObjective].concat(c);
      }
    });

    this.setState({ [`adsToCompare${selection}`]: ccm });
  };

  getRawAdName = (adName) => {
    const splitName = adName.split('_');

    if (!isNaN(splitName[0])) {
      splitName.splice(0, 1);
    }

    splitName.splice(0, 1);
    return splitName.join(' ');
  };

  populateDataToCopy = (creativeObject) => {
    const adCopyData = {
      ad_title: '',
      ad_body: '',
      ad_link: ''
    };
    if (creativeObject.link_data) {
      if (
        creativeObject.link_data &&
        creativeObject.link_data.child_attachments
      ) {
        const carouselTitles = creativeObject.link_data.child_attachments.map(
          (l) => l.name
        );
        const carouselLinks = creativeObject.link_data.child_attachments.map(
          (l) => l.description
        );
        adCopyData.ad_title = carouselTitles;
        adCopyData.ad_link = carouselLinks;
        adCopyData.ad_body = creativeObject.link_data.message;
      } else {
        adCopyData.ad_link = creativeObject.link_data.link;
        adCopyData.ad_title = creativeObject.link_data.name;
        adCopyData.ad_body = creativeObject.link_data.message;
      }
    } else if (creativeObject.template_data) {
      adCopyData.ad_title = creativeObject.template_data.message;
      adCopyData.ad_body = creativeObject.template_data.description;
      adCopyData.ad_link = creativeObject.template_data.link;
    } else if (creativeObject.video_data) {
      adCopyData.ad_title = creativeObject.video_data.title;
      adCopyData.ad_body = creativeObject.video_data.message;
      if (
        creativeObject.video_data.call_to_action &&
        creativeObject.video_data.call_to_action.value &&
        creativeObject.video_data.call_to_action.value.link
      ) {
        adCopyData.ad_link =
          creativeObject.video_data.call_to_action.value.link;
      }
    }
    return adCopyData;
  };

  buildPreviewObject = async (ad, selection) => {
    const targetingSentenceLines = await getTargetingSentencelines(
      ad.id,
      this.state.token
    );
    const adcreatives = ad.adcreatives;
    const link = ad.creative.object_story_spec;
    let ll = [];
    let l = null;
    let canvasName = {};
    // eslint-disable-next-line no-unused-vars
    let leadFormName = {};
    // eslint-disable-next-line no-unused-vars
    let adCopyData = {
      ad_title: '',
      ad_body: '',
      ad_link: ''
    };
    try {
      if (link) {
        adCopyData = this.populateDataToCopy(link);

        if (link.link_data && link.link_data.child_attachments) {
          link.link_data.child_attachments.map((l) => {
            ll.push(l.link);
          });
        }

        if (
          link.video_data &&
          link.video_data.call_to_action &&
          link.video_data.call_to_action &&
          link.video_data.call_to_action.value &&
          link.video_data.call_to_action.value.link
        ) {
          l = link.video_data.call_to_action.value.link;
          ll.push(l);
        }

        if (link.call_to_action && link.call_to_action.link) {
          l = link.call_to_action.link;
          ll.push(l);
        }

        if (link.link_data && link.link_data.link) {
          l = link.link_data.link;
          ll.push(l);
        }

        if (link.template_data && link.template_data.link) {
          l = link.template_data.link;
          ll.push(l);
        }

        if (
          link.link_data &&
          link.link_data.call_to_action &&
          link.link_data.call_to_action.value &&
          link.link_data.call_to_action.value.lead_gen_form_id
        ) {
          try {
            leadFormName = await getLead(
              link.link_data.call_to_action.value.lead_gen_form_id,
              this.state.token
            );
          } catch (error) {
            leadFormName = 'You need permission to access this Lead Form';
          }
          ll = [];
        }
      }
    } catch (e) {
      console.log('urls error', e);
      ll = [];
    }

    let isCanvas = false;
    ll.map(async (l) => {
      if (l.split('canvas_doc').length > 1) {
        isCanvas = true;
        canvasName = await getCanvas(_.last(l.split('/')), this.state.token);
      }
    });

    // eslint-disable-next-line no-unused-expressions
    isCanvas ? (ll = []) : null;

    const desktopResult = await getAdPreview(
      ad.id,
      'DESKTOP_FEED_STANDARD',
      this.state.token
    );
    const mobileResult = await getAdPreview(
      ad.id,
      'MOBILE_FEED_STANDARD',
      this.state.token
    );

    const preview = {
      desktop: desktopResult.data,
      mobile: mobileResult.data
    };

    let deskUrl = preview.desktop[0].body;
    deskUrl = deskUrl.substring(deskUrl.indexOf('src') + 5);
    deskUrl = deskUrl.substring(0, deskUrl.indexOf('"'));
    let mobUrl = preview.mobile[0].body;
    mobUrl = mobUrl.substring(mobUrl.indexOf('src') + 5);
    mobUrl = mobUrl.substring(0, mobUrl.indexOf('"'));
    preview.mobile = `<iframe src="${mobUrl}" width="335" height="620" scrolling="no" style="border: none;"></iframe>`;
    preview.desktop = `<iframe src="${deskUrl}" width="720" height="690" scrolling="yes" style="border: none;"></iframe>`;

    let st = Date.parse(ad.adset.start_time);
    let et = Date.parse(ad.adset.end_time);

    st = new Date(st);
    st = st.toLocaleString('en-us', {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    });

    et = new Date(et);
    et = et.toLocaleString('en-us', {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    });

    if (ad.name.split('Collection').length > 1) {
      preview.desktop =
        '<span style="height: 720px; width: 720px;">This ad type is mobile-only, so no desktop preview exists.</span>';
    }

    if (
      ad.name.split('360').length > 1 &&
      ad.campaign.objective === 'VIDEO_VIEWS'
    ) {
      preview.mobile = preview.mobile.replace('height="720"', 'height="300"');
      preview.mobile +=
        '<div class="ui segment floated left inline text" style="margin-left: 10px; width:320px"><p>Due to differences in hardware, mobile 360 video cannot be previewed via desktop.</p><p>Please use the desktop preview window to view your content.</p></div>';
    }

    preview.mobile = preview.mobile.replace(
      'scrolling="yes"',
      'scrolling="no"'
    );

    const previewObject = {
      start_time: st,
      end_time: et,
      destination_url: ll,
      ad_status: ad.effective_status,
      canvas_name: canvasName,
      ad_name: this.getRawAdName(ad.name),
      ad_id: ad.id,
      campaignObjective: ad.campaign.objective,
      url_tags:
        adcreatives.data.length >= 0 ? adcreatives.data[0].url_tags : '',
      desktop_iframe_url: preview.desktop,
      mobile_iframe_url: preview.mobile,
      targetingSentenceLines,
      selection
    };

    return previewObject;
  };

  initializeTabs = () => {
    const tabs = [];
    if (
      this.state.adsToCompareFirst.LINK_CLICKS.length > 0 ||
      this.state.adsToCompareSecond.LINK_CLICKS.length > 0
    ) {
      const ads = this.sortAdsByFormat(
        this.state.adsToCompareFirst.LINK_CLICKS,
        this.state.adsToCompareSecond.LINK_CLICKS
      );
      tabs.push({ menuItem: 'Traffic Ads', ads });
    }

    if (
      this.state.adsToCompareFirst.LEAD_GENERATION.length > 0 ||
      this.state.adsToCompareSecond.LEAD_GENERATION.length > 0
    ) {
      const ads = this.sortAdsByFormat(
        this.state.adsToCompareFirst.LEAD_GENERATION,
        this.state.adsToCompareSecond.LEAD_GENERATION
      );
      tabs.push({ menuItem: 'Lead Ads', ads });
    }

    if (
      this.state.adsToCompareFirst.VIDEO_VIEWS.length > 0 ||
      this.state.adsToCompareSecond.VIDEO_VIEWS.length > 0
    ) {
      const ads = this.sortAdsByFormat(
        this.state.adsToCompareFirst.VIDEO_VIEWS,
        this.state.adsToCompareSecond.VIDEO_VIEWS
      );
      tabs.push({ menuItem: 'Video Ads', ads });
    }

    if (
      this.state.adsToCompareFirst.PRODUCT_CATALOG_SALES.length > 0 ||
      this.state.adsToCompareSecond.PRODUCT_CATALOG_SALES.length > 0
    ) {
      const ads = this.sortAdsByFormat(
        this.state.adsToCompareFirst.PRODUCT_CATALOG_SALES,
        this.state.adsToCompareSecond.PRODUCT_CATALOG_SALES
      );
      tabs.push({ menuItem: 'Dynamic Ads', ads });
    }

    if (
      this.state.adsToCompareFirst.CONVERSIONS.length > 0 ||
      this.state.adsToCompareSecond.CONVERSIONS.length > 0
    ) {
      const ads = this.sortAdsByFormat(
        this.state.adsToCompareFirst.CONVERSIONS,
        this.state.adsToCompareSecond.CONVERSIONS
      );
      tabs.push({ menuItem: 'Site Visits', ads });
    }

    return tabs;
  };

  renderMenuItemTab = (campaignKey) => (
    <Menu.Item key={campaignKey}>{campaignKey}</Menu.Item>
  );

  renderCampaignsTabs = () => {
    const tabs = this.initializeTabs();
    // eslint-disable-next-line no-unused-vars
    const ads = this.sortAdsByFormat(
      this.state.adsToCompareFirst.LINK_CLICKS,
      this.state.adsToCompareSecond.LINK_CLICKS
    );
    const tabsItems = tabs.map((tab) => ({
      menuItem: this.renderMenuItemTab(tab.menuItem),
      render: () => (
        <Tab.Pane>
          <ComparerTab
            tabName={tab.menuItem}
            firstAds={tab.ads.sortedAdsFirst}
            secondAds={tab.ads.sortedAdsSecond}
          />
        </Tab.Pane>
      )
    }));

    return <Tab panes={tabsItems} />;
  };

  render() {
    return (
      <div className="page-container">
        <div className="container">
          <Grid>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Dropdown
                  placeholder="Ad Accounts"
                  search
                  selection
                  options={this.state.accountOptions}
                  onChange={this.onAccountSelect}
                />
              </Grid.Column>
            </Grid.Row>
            <Divider />
            <Grid.Row columns={2}>
              <Grid.Column>
                {this.state.showYearSelector ? (
                  <Dropdown
                    placeholder="Year"
                    id="FirstYearSelector"
                    search
                    selection
                    value={this.state.selectedFirstYear}
                    options={this.state.years}
                    onChange={this.onYearSelect}
                  />
                ) : this.state.showYearLoader ? (
                  <Container>
                    <Loader inline className="active" />{' '}
                  </Container>
                ) : null}
                <Divider hidden />
                {this.state.showFirstMonthSelector ? (
                  <div>
                    <Dropdown
                      placeholder="Month"
                      id="FirstMonthSelector"
                      search
                      selection
                      options={this.state.FirstMonths}
                      onChange={this.onMonthSelect}
                    />
                  </div>
                ) : this.state.showFisrtMonthLoader ? (
                  <Container>
                    <Loader inline className="active" />
                  </Container>
                ) : null}
              </Grid.Column>
              <Grid.Column>
                {this.state.showYearSelector ? (
                  <Dropdown
                    placeholder="Year"
                    id="SecondYearSelector"
                    search
                    selection
                    value={this.state.selectedSecondYear}
                    options={this.state.years}
                    onChange={this.onYearSelect}
                  />
                ) : this.state.showYearLoader ? (
                  <Container>
                    <Loader inline className="active" />{' '}
                  </Container>
                ) : null}
                <Divider hidden />
                {this.state.showSecondMonthSelector ? (
                  <div>
                    <Dropdown
                      placeholder="Month"
                      id="SecondMonthSelector"
                      search
                      selection
                      options={this.state.SecondMonths}
                      onChange={this.onMonthSelect}
                    />
                  </div>
                ) : this.state.showSecondMonthLoader ? (
                  <Container>
                    <Loader inline className="active" />
                  </Container>
                ) : null}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider hidden />
          {this.state.processing ? <Loader inline className="active" /> : null}
          <span className="processing-message">{this.state.message}</span>
          {this.state.showTabs ? <div>{this.renderCampaignsTabs()}</div> : null}
        </div>
      </div>
    );
  }
}

export default AdComparer;



// WEBPACK FOOTER //
// ./src/screens/AdComparer/AdComparer.js